import api from "../../API/apiConfig";
//1. View Log Call Of Member
export const viewMemberLogCall = async (type, id) => {
  try {
    const response = await api.get(`/log_call/list-type?logCallType=${type}&recordId=${id}`);
    console.log("API Response:", response); 
    return response;
  } catch (error) {
    console.error("Error in viewMemberLogCall:", error);
    throw error;
  }
};
//2. Update Log Call
export const updateLogCall = async (id, logCallUpdateData) => {
  return await api.put(`log_call/update/${id}`, logCallUpdateData);
};
//3. Delete Log Call
export const deleteLogCall = async (id) => {
  return await api.delete(`log_call/delete/${id}`);
};

//4. Create Log Call
export const createLogCall = async (logCallData) => {
  return await api.post(`log_call/add`, logCallData);
}

//5. Log Call Detail
export const detailLogCall = async (id) => {
  return await api.get(`log_call/detail/${id}`);
}
//6. Get All User
export const userList = async(id) => {
 
  return await api.get(`users/${id}`);
}
//7. Update Log Call Status
export const updateLogCallStatus = async (id, status) => {
  console.log("ID:", id, "Status:", status);
  return await api.put(`log_call/update-status/${id}`, {status : status});
};

//8. Load Leads Data
export const listLeadsOption = async() => {
  return await api.get(`/leads/list-all`);
}
//9. Load Contacts Data 
export const listContactsOptionn = async() =>{
  return await api.get(`/contacts/list-all`);
}
//10. Load Opportuniies Data based on RelatedTo
export const listOpportunitiesOption = async() =>{
  return await api.get(`/opportunities/list`);
}
//11. Load CampaignS Data based on Related To
export const listCampaignsOption = async() =>{
  return await api.get(``);
}
//12. Load Accounts Data based on Related to 
export const listAccountsOption = async() =>{
  return await api.get(`/accounts/list-all`);
}
